import { Outlet } from "react-router-dom";
import useSharedData from "../hooks/useSharedData";
import Layout403 from "../modules/public/errorHandling/403";

function ProtectedAgentRoutes() {
  const { isAgent } = useSharedData();

  if (!isAgent) {
    return <Layout403 />;
  }

  return <Outlet />;
}

export default ProtectedAgentRoutes;
